<template lang="pug">
  ValidationProvider(:rules="rules", :name="name" v-slot="{ errors }")
    v-autocomplete(:items="items"
      item-text="text"
      item-value="value"
      return-object
      v-model="valuefield"
      :disabled="disabled"
      outlined
      dense
      chips
      small-chips
      :multiple="multiple"
      :error="errors.length > 0"
      @input="inputFill")
      template(v-slot:label)
        v-icon.pr-1(v-if="isRequired" color="red accent-2" size="12") mdi-asterisk
        | {{ label }}
      template(v-slot:selection="data")
        v-chip(v-if="data.item" v-bind="data.attrs", :input-value="data.selected" close @click="data.select" @click:close="removeData(data.item)")
          | {{ data.item.text }}
      template(v-slot:item="{ item, attrs }")
        div.list-item-hide-custom(@click="toggleItem(item, attrs.inputValue)")
        v-list-item-action
          v-checkbox(v-model="attrs.inputValue")
        v-list-item-content
          v-list-item-title.pl-2 {{ item.text }}
    span.red--text.text--accent-2(v-if="errors.length > 0")
      v-icon(color="red accent-2") mdi-alert
      |  {{ errors[0] }}
</template>

<script>
  export default {
    name: "BaseChipSelectField",
    model: {
      prop: 'value',
      event: 'input',
    },
    props: {
      value: {
        type: [Array, Object],
        default: function(){
          return []
        }
      },
      disabled: {
        type: Boolean,
        default: false
      },
      rules: {
        type: [String, Object],
        default: ''
      },
      label: {
        type: String,
        default: ''
      },
      items: {
        type: Array,
        default: function(){
          return []
        }
      },
      multiple: {
        type: Boolean,
        default: true
      },
      name: {
        type: String,
      },
    },
    data:() => ({
      valuefield: null
    }),
    computed: {
      isRequired(){
        if(typeof this.rules == 'string'){
          return this.rules.includes('required');
        } else {
          return this.rules['required'] ? true : false;
        }
      }
    },
    watch: {
      value: function(val){
        this.valuefield = val;
      }
    },
    created(){
      if (this.value != null) {
        if (this.multiple) {
          this.valuefield = this.value.map(item => item);
        } else if (Array.isArray(this.value)){
          const val = this.value[0];
          this.valuefield = { ...val };
          this.$emit('input',this.valuefield);
        } else {
          const val = this.value;
          this.valuefield = { ...val };
          this.$emit('input',this.valuefield);
        }
      }
    },
    methods:{
      inputFill(){
        this.$emit('input', this.valuefield);
      },
      toggleItem(item, unselected){
        if(unselected) {
          this.$emit('deleteItem', item);
        } else {
          this.$emit('addedItem', item);
        }
      },
      removeData(item){
        this.$emit('deleteItem', item);
        if (this.multiple) {
          this.valuefield = this.valuefield.filter((match)=>{
            return match.value != item.value;
          });
        } else {
          this.valuefield = null;
        }
        this.inputFill();
      },
    },
  }
</script>

<style lang="sass">
.list-item-hide-custom
  position: absolute
  top: 0
  left: 0
  width: 100%
  height: 100%
  opacity: 0.5
</style>